<div class="autocomplete" id="{{typeElements+'-container'}}">
  <input type="text" [ngClass]="allBorderRadius?'border-radius':'no-border-radius'"
    [class.required]="inputs?.required && !inputs?.verified"
    class="form-control input-suggestions {{inputs?.bgColor?inputs?.bgColor:''}} {{typeElements}}"
    name="{{typeElements+'-input'}}" id="{{typeElements+'-input'}}" [(ngModel)]="inputs.value"
    placeholder="{{placeholder}}" (input)="handleInput($event)" (click)="focusInput($event)"
    (change)="verifiedInput($event)" autocomplete="off" [disabled]="ruleToDisabled">
  
  <button *ngIf="enableSelect" class="btn btn-secondary btn-sm mt-1 w-100" (click)="toggleSelectAll()">
    {{ allSelected ? 'Deseleccionar Todos' : 'Seleccionar Todos' }}
  </button>

  <cdk-virtual-scroll-viewport [itemSize]="10"
    [style.height]="dynamicHeight"
    class="suggestions" id="{{typeElements+'-suggestions'}}">
    <div *cdkVirtualFor="let filter of filterElements" 
        class="suggestions-item"
        [ngClass]="{
          'padding-suggestion': padding,
          'selected-item': filter.selected
        }"
        (click)="toggleSelection(filter)">
      
      <span *ngIf="enableSelect">
        <input type="checkbox" [(ngModel)]="filter.selected" (click)="$event.stopPropagation()">
      </span>
      
      <span *ngIf="!custom">{{getTitleData(filter)}}</span>
      
      <ng-container *ngIf="custom">
        <ng-container *ngTemplateOutlet="itemsTemplate; context: { $implicit: filter }"></ng-container>
      </ng-container>
    </div>

  </cdk-virtual-scroll-viewport>

  <span class="input-status" [class.text-info]="inputs.class.includes('list')"
    [class.text-danger]="inputs.class.includes('xmark') || inputs.class.includes('asterisk')"
    [class.text-success]="inputs.class.includes('check')">
    <i *ngIf="inputs.class!='typing' && inputs.class!='loading'" [tooltip]="inputs.message"
      id="{{typeElements+'-status'}}" class="fa {{inputs.class}}"></i>
    <div *ngIf="inputs.class=='typing'" class="typing">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div *ngIf="inputs.class=='loading'" class="loading">
      <app-loading-animation></app-loading-animation>
    </div>
  </span>
</div>
